import { MODALS_ID } from '../../../constants'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

function SuccessEmailModal({ onDismiss }: { onDismiss: () => void }) {
  return (
    <Modal id={MODALS_ID.SUCCESS_EMAIL}>
      <Text size={16} weight={500} $textAlign="center">
        이메일 주소가 등록되었어요.
      </Text>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={onDismiss}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SuccessEmailModal
